require('./authorizeBizum.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

//@core
const { formatText } = require('core/i18n').i18n;
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')

//@commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');

//@constants
const {
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP,
    FOURTH_STEP,
    WIZARD_VERTICAL_VIEW_MODE
} = require('constants/index');
const { AUTHORIZE_BIZUM} = require('constants/contactCenter/operationTypes');
const { ERROR_USER_REGISTERED_IN_OTHER_ENTITY } = require('constants/contactCenter/errorTypes');

// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const AuthorizeBizumStep1 = require('./steps/authorizeBizumStep1/authorizeBizumStep1');
const AuthorizeBizumStep2 = require('./steps/authorizeBizumStep2/authorizeBizumStep2');
const AuthorizeBizumStep3 = require('./steps/authorizeBizumStep3/authorizeBizumStep3');
const PreleaveCancelModal = require('components/contactCenter/preleaveCancelModal/preleaveCancelModal');
const { BizumConfirmation } = require('routes/bizumConfirmation/bizumConfirmation');

class AuthorizeBizum extends React.Component {

    constructor(props) {
        super(props);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleToggleCancelModal = this.handleToggleCancelModal.bind(this);
        this.handleCancelWizard = this.handleCancelWizard.bind(this);
        this.onHandleGobackCustomMessageBox = this.onHandleGobackCustomMessageBox.bind(this);
        this.state = {
            showModal: false
        };
    }

    componentWillMount(){
        const {requestPhoneOTP} = this.props;
        requestPhoneOTP();
    }

    componentWillUnmount() {
        this.props.UserDataReset();
        this.props.onBizumDataReset();
    }

    handleFinish(){
        const {handleFinish} = this.props;
        handleFinish();
    }

    handleToggleCancelModal(){
        this.setState({showModal: !this.state.showModal});
    }

    handleCancelWizard(){
        this.props.history.push('/myprofile/transfers');
    }

    onHandleGobackCustomMessageBox(){
        this.props.history.push('/myprofile/transfers');
    }

    getBreadcrumbMap(){
        const breadcrumpMap = [
            {
                text: formatText('breadcrumb-transfers'),
                url: '/myprofile/transfers'
            },
            {
                text: formatText('authorizeBizum-titleHeader'),
                url: ''
            }
        ];

        return breadcrumpMap;
    }

    buildCustomMessageBoxSuccess(){
        const title = formatText('authorizeBizum-titleMessageBoxSuccess');
        const extraContent = <BlockInfo>{formatText('authorizeBizum-extraContentMessageBoxSuccess')}</BlockInfo>
        const textLink = formatText('authorizeBizum-textLinkMessageBoxSuccess').toUpperCase();

        return (
            <CustomMessageBox
                icon="icon-success"
                title={title}
                extraContent={extraContent}
                textLink={textLink}
                goBackHandler={this.onHandleGobackCustomMessageBox}
            />
        )
    }

    buildCustomMessageBoxFailure(){
        const title = formatText('authorizeBizum-titleMessageBoxFailure');
        const extraContent = <BlockInfo>{formatText('authorizeBizum-extraContentMessageBoxFailure')}</BlockInfo>
        const textLink = formatText('authorizeBizum-textLinkMessageBoxFailure').toUpperCase();

        return (
            <CustomMessageBox
                icon="icon-warning"
                title={title}
                extraContent={extraContent}
                textLink={textLink}
                goBackHandler={this.onHandleGobackCustomMessageBox}
            />
        )
    }

    buildPreleaveCancelModal(){
        return (
            <PreleaveCancelModal
                isOpen={this.state.showModal}
                onCancel={this.handleCancelWizard}
                onCloseModal={this.handleToggleCancelModal}
                onStayHere={this.handleToggleCancelModal}
            />
        );
    }

    buildBizumPortabilityStep() {
        return (
            <BizumConfirmation />
        );
    }

    buildWizard(){
        const {
            immAuthorizeBizum,
            immUserDataPhone,
            immProfileEditor,
            validateStep,
            setVisibleStep,
            immAccounts,
            onAccountChange,
            onSendTermsAndConditions,
            onAcceptTermsAndConditions,
            onSetError,
            requestProfile,
            immProfileFields
        } = this.props;
        const immSteps = immAuthorizeBizum.get('steps');

        const immStepOne = immSteps.get(FIRST_STEP);
        const immStepTwo = immSteps.get(SECOND_STEP);
        const immStepThree = immSteps.get(THIRD_STEP);
        const immStepFour = immSteps.get(FOURTH_STEP);

        const operationParams = immStepFour.toJS().operationParams;
        const visibleStep = immAuthorizeBizum.get('visibleStep');
        const isFetching = immAuthorizeBizum.get('isFetching');
        const phoneNumberBizum =  immUserDataPhone.getIn(['data','telefono']) || '-';
        const emailBizum = immProfileEditor.get('steps').get(0).get('email');

        const invalidSecurityData = immAuthorizeBizum.get('invalidSecurityDataError');

        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel: () =>{},
            finish: this.handleFinish,
            cancel: this.handleToggleCancelModal
        }

        return (
            <Wizard
                viewMode={WIZARD_VERTICAL_VIEW_MODE}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}

            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    nextButtonLabel="authorizeBizumStep1-nextButtonLabel"
                >
                    <AuthorizeBizumStep1
                        phoneNumber={phoneNumberBizum}
                        immAccounts={immAccounts}
                        immStep={immStepOne}
                        onAccountChange={onAccountChange}
                    />
                </WizardStep>

                <WizardStep
                    position="middle"
                    omitPreviousButton={true}
                    cancelButton={true}
                    nextButtonLabel="authorizeBizumStep2-nextButtonLabel"
                >
                    <AuthorizeBizumStep2
                        emailBizum={emailBizum}
                        onSendTermsAndConditions={onSendTermsAndConditions}
                        immStep={immStepTwo}
                        requestProfile={requestProfile}
                        immProfile={immProfileFields}
                        immAuthorizeBizum={immAuthorizeBizum}
                    />
                </WizardStep>
                <WizardStep
                    position="middle"
                    omitPreviousButton={true}
                    cancelButton={true}
                    nextButtonLabel="authorizeBizumStep3-nextButtonLabel"
                >
                    <AuthorizeBizumStep3
                        onAcceptTermsAndConditions={onAcceptTermsAndConditions}
                        onSetError={onSetError}
                        immStep={immStepThree}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    omitPreviousButton={true}
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    isLoading={isFetching}
                    immFinalButton="authorizeBizumVerifyOtepStep-confirmButtonText"
                >
                    <VerifyOtpStep
                        operationType={AUTHORIZE_BIZUM}
                        operationParams={operationParams}
                        invalidSecurityData={invalidSecurityData}
                    />
                </WizardStep>
            </Wizard>
        )
    }

    buildContent(){
        const {immUserDataPhone, immAuthorizeBizum} = this.props;
        const isFetchingTelefono =  immUserDataPhone.get('isFetching');
        const hasErrorFinish = !!immAuthorizeBizum.get('error');
        const hasErrorFinishCode = immAuthorizeBizum.get('error');
        const hasBeenSentFinish = immAuthorizeBizum.get('hasBeenSent');
        const wizard = this.buildWizard();
        const preleaveCancelModal = this.buildPreleaveCancelModal();
        const messageBoxSuccess = this.buildCustomMessageBoxSuccess();
        const messageBoxFailure = this.buildCustomMessageBoxFailure();
        const bizumPortabilityStep = this.buildBizumPortabilityStep();

        let content

        if(isFetchingTelefono){
            content = (<LoadingSection/>);
        }else if (!hasErrorFinish && hasBeenSentFinish){
            content = messageBoxSuccess;
        } else if ((hasErrorFinish || hasErrorFinishCode == null) && !hasBeenSentFinish) {
            content = messageBoxFailure;
        } else if (hasErrorFinishCode == ERROR_USER_REGISTERED_IN_OTHER_ENTITY && hasBeenSentFinish) {
            content = (
                <div>
                    {bizumPortabilityStep}
                </div>
            );
        }else{
            content =  (
                <div>
                    {wizard}
                    {preleaveCancelModal}
                </div>
            );
        }
        return content;
    }

    render() {
        const breadcrumpMap = this.getBreadcrumbMap();
        const content = this.buildContent();
        const gridViewClassName = contactCenterClassName('grid-view__body', 'authorize-bizum__body', 'grid-view--content-position-negative');

        return (
            <section className="authorize-bizum">
                <OKCover size="medium" section="transfers">
                    <OKHeaderSubPage
                        breadcrumbConfig={breadcrumpMap}
                        finalTitle={formatText('authorizeBizum-titleHeader')}
                        isSubtitleLeftCapital={false}
                        overlap={true}
                    >
                    </OKHeaderSubPage>
                </OKCover>
                <div className={gridViewClassName}>
                    {content}
                </div>
            </section>
        );
    }
}

AuthorizeBizum.propTypes = {
    history: PropTypes.object.isRequired,
    immAuthorizeBizum: PropTypes.object.isRequired,
    immProfileFields : PropTypes.object.isRequired,
    immUserDataPhone : PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immProfileEditor: PropTypes.object,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep :  PropTypes.func.isRequired,
    onSendTermsAndConditions: PropTypes.func.isRequired,
    onAcceptTermsAndConditions: PropTypes.func.isRequired,
    onAccountChange: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    requestPhoneOTP : PropTypes.func.isRequired,
    UserDataReset :  PropTypes.func.isRequired,
    onSetError: PropTypes.func.isRequired,
    onBizumDataReset :  PropTypes.func.isRequired,
    requestProfile : PropTypes.func.isRequired
}

module.exports = withRouter(AuthorizeBizum);
